import { useEffect, useState, ChangeEvent } from 'react';
import { useDispatch } from 'react-redux';
import {
    useGridSnapshot,
    useIsDataGridPaneVisible,
} from '../../../selectors/index.hooks';
import { isDataSegmentsContextEnabled } from '@/app/constants/AppConfig';
import {
    activateGrid,
    activatePreviewWithSelectedOptions,
    IActivatePreviewParams,
} from '@/app/state/ui/discovery/snapshotting';
import { showBookmarskListDialog } from '@/app/state/ui/dialog';
import { useGridSourceSet } from '../../../selectors/composed/index.hooks';

import { ISourceSet } from '@/app/state/types';
import { VALID_SOURCE_SET_IDS } from '../DataGridPaneHeader';

export const ARCHIVE_EVENTS_LABEL_CASES = [
    'archiveEventsTanksDefault',
    'archiveEventsWithAttachments',
];

export const normalizeSourceSetId = (
    id: string | undefined,
    sourceSet: ISourceSet | null
): string => {
    if (!id) return '';

    if (id.includes('archiveEvents')) {
        if (ARCHIVE_EVENTS_LABEL_CASES.some((key) => id.includes(key))) {
            return sourceSet?.label || id;
        }
        return 'archiveEvents';
    }

    if (VALID_SOURCE_SET_IDS.includes(id as any)) {
        return id;
    }

    return sourceSet?.label || '';
};

export function useSelectedGrid(sourceSetId: string | undefined) {
    const dispatch = useDispatch();
    const gridSnapshot = useGridSnapshot();
    const sourceSet = useGridSourceSet();
    const isDataGridPaneVisible = useIsDataGridPaneVisible();
    const [selectedGrid, setSelectedGrid] = useState(
        normalizeSourceSetId(sourceSetId, sourceSet)
    );

    useEffect(() => {
        setSelectedGrid(normalizeSourceSetId(sourceSetId, sourceSet));
    }, [sourceSetId, sourceSet]);

    const handleOpenDataSegments = () => {
        if (isDataSegmentsContextEnabled()) {
            const params: IActivatePreviewParams = {
                elementCollectionName: 'dataSegments',
                elementId: null,
                elementType: 'dataSegments',
                mode: 'preview',
                snapshot: { type: 'preview', level: 0 },
                closeGrid: true,
            };
            dispatch(activatePreviewWithSelectedOptions(params));
        } else {
            dispatch(showBookmarskListDialog({}));
        }
    };

    const handleSelectDataSource = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setSelectedGrid(value);

        if (gridSnapshot?.sourceSetId === value && isDataGridPaneVisible)
            return;

        if (value === 'dataSegments') {
            handleOpenDataSegments();
            return;
        }

        if (value !== 'archiveEvents') {
            dispatch(
                activateGrid(value, {
                    type: 'category',
                    level: 0,
                })
            );
        }
    };

    return { selectedGrid, handleSelectDataSource };
}
